export const HIGHLIGHT_SMART_DURATION = 0;

export const HIGHLIGHT_DURATIONS = [
  { value: HIGHLIGHT_SMART_DURATION, label: '智能时长', hint: '按直播类型自动识别整段起止（游戏高燃 / 唱歌或舞蹈成段 / 其他互动）' },
  { value: 15, label: '15 秒', hint: '短爆点' },
  { value: 30, label: '30 秒', hint: '固定 30 秒' },
  { value: 60, label: '60 秒', hint: '完整高光' },
  { value: 90, label: '90 秒', hint: '加长片段' },
  { value: 120, label: '120 秒', hint: '2 分钟' },
  { value: 180, label: '180 秒', hint: '3 分钟' },
];

export const DEFAULT_HIGHLIGHT_DURATION = HIGHLIGHT_SMART_DURATION;

export const HIGHLIGHT_CANDIDATE_OPTIONS = [
  { value: 3, label: '3 条' },
  { value: 5, label: '5 条' },
  { value: 8, label: '8 条' },
  { value: 10, label: '10 条' },
];

export const DEFAULT_HIGHLIGHT_CANDIDATE_COUNT = 5;

/** 展示顺序：游戏 → 唱歌 → 舞蹈 → 其他；API 值仍为 SHOW 表示「其他」 */
export const LIVE_CATEGORIES = [
  { value: 'GAME', label: '游戏' },
  { value: 'SING', label: '唱歌' },
  { value: 'DANCE', label: '舞蹈' },
  { value: 'SHOW', label: '其他' },
];

export const DEFAULT_LIVE_CATEGORY = 'GAME';
